const EMAIL_VERIFY_PATHS = new Set([
  '/dashboard',
  '/checkout',
  '/wallet',
  '/orders',
  '/cart',
  '/subscriptions',
  '/withdraw',
  '/minutes',
  '/mobile-topup',
  '/disputes',
  '/messages',
  '/notifications',
  '/referral',
]);

export function pathNeedsEmailVerification(pathname) {
  const path = pathname || '/';
  if (path === '/verify-email' || path.startsWith('/login') || path.startsWith('/register')) return false;
  return EMAIL_VERIFY_PATHS.has(path) || path.startsWith('/pay/') || path.startsWith('/seller');
}

export function userMustVerifyEmail(currentUser, pathname) {
  if (!currentUser || currentUser.role === 'admin') return false;
  if (currentUser.email_verified !== false) return false;
  return pathNeedsEmailVerification(pathname);
}
